module.exports = __webpack_public_path__ + "static/media/AB_payment_verified.7fc550f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/AB_payment_verified.png
// module id = 1263
// module chunks = 0